import { render } from "./Notion.vue?vue&type=template&id=6be2b1b4&scoped=true"
import script from "./Notion.vue?vue&type=script&lang=js"
export * from "./Notion.vue?vue&type=script&lang=js"

import "./Notion.vue?vue&type=style&index=0&id=6be2b1b4&lang=css"
import "./Notion.vue?vue&type=style&index=1&id=6be2b1b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be2b1b4"]])

export default __exports__